import { Edit } from '@mui/icons-material'
import { Card, CardContent, CardHeader, CircularProgress, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonButton from 'components/ArgonButton'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import userStore from 'store/userStore'
import InputAnggaranKas from './InputAnggaranKas'

const listBulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
];

const AnggaranKas = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [loading, setLoading] = useState(false)

    const [updating, setUpdating] = useState(false)
    const [editAnggaranKas, setEditAnggaranKas] = useState(false)
    const handleCloseDialog = () => {
        setEditAnggaranKas(false)
    }
    
    const [totalKeuangan, setTotalKeuangan] = useState(0)
    const [totalFisik, setTotalFisik] = useState(0)
    
    const [anggaranKas, setAnggarankas] = useState([])
    const reqAnggaranKas = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/anggaran-kas/filter',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setAnggarankas(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqAnggaranKas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updating])

    useEffect(() => {
        if (anggaranKas.length > 0) {
            let x = 0;
            let y = 0;
            anggaranKas.forEach((rs) => {
                let z = parseFloat(rs.target_fisik.replace(',', '.')) * 100
                x += parseInt(rs.target_keuangan)
                y += z
            })
            setTotalKeuangan(x)
            setTotalFisik(y)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [anggaranKas])

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Anggaran Kas</ArgonTypography>
                        }
                        action={
                            <ArgonButton
                                variant='contained'
                                color="primary"
                                size="small"
                                startIcon={<Edit />}
                                onClick={() => {
                                    setEditAnggaranKas(true)
                                }}
                            >
                                Edit
                            </ArgonButton>
                        }

                    />
                    <CardContent>
                        {
                            loading ?
                                <ArgonBox align="center">
                                    <CircularProgress />
                                </ArgonBox>
                                :
                                <Table aria-label="simple table">
                                    <TableHead key={0}>
                                        <TableRow>
                                            <TableCell rowSpan={2} sx={{ fontSize: 'small' }}>No</TableCell>
                                            <TableCell rowSpan={2} sx={{ fontSize: 'small' }}>Bulan</TableCell>
                                            <TableCell colSpan={2} sx={{ fontSize: 'small', textAlign: 'center' }}>Target Realisasi Keuangan</TableCell>
                                            <TableCell rowSpan={2} sx={{ fontSize: 'small', textAlign: 'center' }}>Target Realisasi Fisik</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>Nominal</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>%</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            listBulan.map((bulan, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ fontSize: 'small' }}>{index + 1}</TableCell>
                                                    <TableCell sx={{ fontSize: 'small' }}>{bulan}</TableCell>
                                                    <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>{
                                                        anggaranKas[index]?.target_keuangan ?
                                                            parseInt(anggaranKas[index].target_keuangan)?.toLocaleString?.('id-ID', {
                                                                style: 'currency',
                                                                currency: 'IDR',
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0,
                                                            })
                                                            :
                                                            0
                                                    }</TableCell>
                                                    <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>{
                                                        anggaranKas[index]?.target_keuangan ?
                                                            ((parseInt(anggaranKas[index].target_keuangan) / totalKeuangan) * 100).toFixed(2) + '%'
                                                            :
                                                            0 + "%"

                                                    }</TableCell>
                                                    <TableCell sx={{ fontSize: 'small', textAlign: 'center' }}>{anggaranKas[index]?.target_fisik + '%' || ''}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={2} sx={{ fontSize: 'small', fontWeight: 'bold' }}>Total</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center', fontWeight: 'bold' }}>{
                                                totalKeuangan.toLocaleString?.('id-ID', {
                                                    style: 'currency',
                                                    currency: 'IDR',
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                })
                                            }</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center', fontWeight: 'bold' }}>100%</TableCell>
                                            <TableCell sx={{ fontSize: 'small', textAlign: 'center', fontWeight: 'bold' }}>{totalFisik/100}%</TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                        }
                    </CardContent>
                </Card>
            </ArgonBox>

            <InputAnggaranKas
                open={editAnggaranKas}
                handleClose={handleCloseDialog}
                updating={updating}
                setUpdating={setUpdating}
                kd_pd={decodedUser.kd_pd}
                tahunAnggaran={tahunAnggaran}
                addReq={addReq}
                decryptedUser={decryptedUser}
                anggaranKas={anggaranKas}
            />
        </ArgonBox>
    )
}

export default AnggaranKas